module.exports = __webpack_public_path__ + "img/265-2.1041bca9.png";